import { Pressable, StyleSheet, PressableProps } from 'react-native';

import { colors, spacing } from '../../../theme';
import PlusIcon from './add-image-plus.svg';

interface Props extends PressableProps {
	size?: number;
}

const DEFAULT_SIZE = 164;

export const PlusButton = ({ size = DEFAULT_SIZE, style, disabled, ...props }: Props) => {
	return (
		<Pressable
			style={[styles.root, { width: size, height: size }, style]}
			disabled={disabled}
			{...props}
		>
			<PlusIcon style={disabled && styles.disabled} />
		</Pressable>
	);
};

const styles = StyleSheet.create({
	root: {
		backgroundColor: colors.white,
		borderRadius: spacing(),
		justifyContent: 'center',
		alignItems: 'center',
	},
	disabled: {
		opacity: 0.5,
	},
});
